import { z } from 'zod';
export const stageTypeSchema = z.enum(['open', 'won', 'lost']);
export const createPipelineSchema = z.object({
    name: z.string().trim().min(1).max(100),
    isDefault: z.boolean().default(false),
    currency: z.string().length(3).default('USD'),
});
export const updatePipelineSchema = createPipelineSchema.partial();
export const pipelineResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    isDefault: z.boolean(),
    currency: z.string(),
    position: z.number().int(),
    stages: z.array(z.object({
        id: z.string().uuid(),
        name: z.string(),
        probability: z.number().int(),
        type: stageTypeSchema,
        rotAfterDays: z.number().int().nullable(),
        /** Freeform labels an admin wants a deal to have before entering this
         * stage (design's "Required to enter" column) — stored and editable
         * here, but not yet enforced by `DealsService#moveStage`; a generic
         * check spanning both standard Opportunity fields ("Value", "Expected
         * close date") and custom fields is a bigger feature than this admin
         * screen, disclosed rather than faked. */
        requiredFields: z.array(z.string()),
        position: z.number().int(),
        dealCount: z.number().int(),
    })),
});
export const createStageSchema = z.object({
    name: z.string().trim().min(1).max(60),
    probability: z.number().int().min(0).max(100),
    type: stageTypeSchema.default('open'),
    rotAfterDays: z.number().int().positive().optional(),
    requiredFields: z.array(z.string().trim().min(1).max(60)).default([]),
});
export const updateStageSchema = createStageSchema.partial().extend({
    position: z.number().int().optional(),
});
export const reorderStagesSchema = z.object({ orderedIds: z.array(z.string().uuid()).min(1) });
export const reorderPipelinesSchema = z.object({ orderedIds: z.array(z.string().uuid()).min(1) });
export const createLossReasonSchema = z.object({ name: z.string().trim().min(1).max(100) });
export const updateLossReasonSchema = z.object({
    name: z.string().trim().min(1).max(100).optional(),
    position: z.number().int().optional(),
});
export const lossReasonResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    position: z.number().int(),
    usageCount: z.number().int(),
});
export const reorderLossReasonsSchema = z.object({ orderedIds: z.array(z.string().uuid()).min(1) });
//# sourceMappingURL=pipeline-config.js.map